import { getPreloadApi } from "./preloadAccess";
export function relaunch(args) {
    getPreloadApi().app.relaunch(args);
}
